module.exports = __webpack_public_path__ + "img/help-ot3.4c2b0d5f.png";